<mng-dialog-header [title]="data.title" [iconName]="data.iconName" [iconColor]="data.iconColor" />

<mat-dialog-content style="padding: 7px 24px 16px">
  @if (data.bodyHtml) {
    <div [innerHtml]="data.bodyHtml"></div>
  }

  @if (showInput && isDateInput) {
    <mng-datepicker
      label="Datum"
      [formControl]="formControl"
      [min]="data.minDate"
      [max]="data.maxDate"
      [fullWidth]="true"
      (keyup.enter)="onEnter(resultValueOk)"
    />
  }

  @if (showInput && !isDateInput) {
    <mat-form-field color="accent" appearance="outline" style="width: 100%; padding-bottom: 0">
      <input
        matInput
        type="text"
        id="dialog_input_text"
        autocomplete="off"
        [formControl]="formControl"
        (keyup.enter)="onEnter(resultValueOk)"
        (focus)="onFocus($event)"
      />
      @if (formControl.hasError('required')) {
        <mat-error> Eingabe ist erforderlich </mat-error>
      }
      @if (data.customValidator && formControl.hasError(data.customValidator.errorId)) {
        <mat-error>{{ data.customValidator.errorMessage }}</mat-error>
      }
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (cancelButton) {
    <button mat-button color="accent" (click)="dialogAction(resultValueCancel)">
      {{ data?.cancelText || 'Abbrechen' }}
    </button>
  }
  @if (okButton) {
    <button mat-button color="accent" [disabled]="isFormInvalid()" (click)="dialogAction(resultValueOk)">
      {{ data.okText?.toUpperCase() || 'OK' }}
    </button>
  }
  @if (noButton) {
    <button mat-button color="accent" (click)="dialogAction(resultValueNo)">
      {{ data.noText?.toUpperCase() || 'NEIN' }}
    </button>
  }
  @if (yesButton) {
    <button cdkFocusRegionstart mat-button color="accent" (click)="dialogAction(resultValueYes)">
      {{ data.yesText?.toUpperCase() || 'JA' }}
    </button>
  }
</mat-dialog-actions>
